export default "__VITE_ASSET__BfkXJtzK__"